import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useAuth } from '@/hooks/useAuth';
import { useQueryParam } from '@/hooks/useQueryParam';
import { QUERY } from '@/constants/common';
import { useUrlAndHashFromPath } from '@/hooks/useUrlAndHashFromPath';

export function useLoginUser() {
  const { replace } = useRouter();
  const { loginUser } = useAuth();
  const [accessToken] = useQueryParam(QUERY.access_token);
  const { trimmedUrl } = useUrlAndHashFromPath([QUERY.access_token]);

  useEffect(() => {
    if (accessToken) {
      (async () => {
        await loginUser({ variables: { accessToken } });
        replace(trimmedUrl, undefined, { scroll: false });
      })();
    }
  }, [accessToken]);

  return !!accessToken;
}
